<template>
  <div class="main_view">
    <div class="form_view">
      <el-card>
        <el-row style="display: grid;justify-content: center;align-items: center">
          <el-col :span="24" class="cont_text">
            <span>
          网站隐私政策本网站由康明斯公司拥有和运营，欢迎访问。本隐私政策是对我们如何收集和处理个人信息以及您如何选择信息收集和使用方法的描述。本政策在以下情况下适用：网站：您使用本网站或者使用发布或链接本隐私政策的其他康明斯网站时；产品和服务：您与康明斯之间就提及或链接本隐私政策的我方产品和/或服务开展互动时；远程通信和互联解决方案@：您使用配备了激活的远程通信设备的商用车辆或设备，将数据传输给康明斯，用于与车辆或设备的正常运行和维护相关的目的，和/或使用我们的互联解决方案在线工具，使客户可以注册远程通信服务时；数字工具：您使用康明斯提供的与我们的商用车辆和设备的诊断和维修服务相关的各种数字工具（包括应用程序）时，例如Guidanz®, INSITE™、INLINE™、QuickServe® Online等。我们收集的个人信息您无需提供有关您的任何信息即可访问我们的网站。但是，只有在提供与互动或服务类型相关的少量个人信息后，您才能获得某些基于网络的服务或获准进入我们网站的某些部分，例如进行产品注册、提交查询、购买商品、申请工作、参与调查。我们收集的信息可能包括：您的身份信息（姓名、电子邮件、电话号码、地址、其他联系方式）您与我们的业务关系（例如，客户、卖方、供应商、求职者等）您对我们的产品或服务的兴趣以及您的偏好（例如，公司名称、您的职位、购买经历、服务互动、销售互动、对我们的特定产品或服务的兴趣）您参加我们的任何活动的注册信息（例如，订阅简讯、注册电子邮箱、参与调查或获取我们提供的其他类似服务）您加入康明斯团队的意向和资格（工作申请、资历、推荐信、适用的证书或执照、就业和学术经历等）您与我们的在线或离线互动（例如，通过社交媒体网站点赞和提供反馈、与我们的客服中心互动等）。您使用配备了激活的远程通信设备的商用车辆或设备，向康明斯传输与安装该设备的车辆/设备的正常运行和维护有关的信息，例如，车辆或设备标识符、故障代码和类似的功能信息、适用日期和时间、位置数据（用于评估道路状况和影响性能的类似因素）、制动和速度信息等（参阅远程通信数据保护声明）。您使用康明斯提供的与商用车辆和设备的诊断和维修服务相关的数字工具和应用程序的有限个人数据（例如，姓名和联系方式）、您选择在线和/或通过应用程序使用的工具和/或应用程序、车辆和/或设备标识符、位置数据（用于维修协助、支持和安排）、付款详细信息等（参阅数字工具数据保护声明）。另请参阅我们的康明斯Cookie声明，了解网站浏览和使用相关信息的收集方式，以及您在拒绝这些匿名化机制时的可用选项。
            </span>
          </el-col>
          <el-col :xl="6" class="back_btn">
            <el-button type="danger" style="width: 100%;" @click="goBack">返回</el-button>
          </el-col>
        </el-row>


      </el-card>

    </div>
  </div>
</template>

<script>

export default {
  name: 'YinSi',
  data () {
    return {

    }
  },
  methods:{

    goBack(){
      this.$router.go(-1);
    }

  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main_view{
  width: 100%;
  height: 100%;
}

/deep/ label{
  margin-bottom: 0PX;
}
.el-card{
  height: 100vh;
  font-size: 18PX;
}
.cont_text{
  text-align: left;
  text-indent: 2em;
}
/deep/.el-card__body{
  border: 1PX solid rgb(187,187,187);
  height: 100%;
}
.back_btn{
  padding-top: 20PX;
  margin: auto;
}
@media screen and (max-width: 768px) {
  .main_view {
    height: auto; /* 移动端高度自适应 */
  }
  .form_view {
    padding-top:5PX ;
    padding-bottom: 5PX;
    width: 94%; /* 移动端占满屏幕宽度 */
    margin: auto;
  }
  .cont_text {
    height: 80vh;
    overflow-y: scroll;
  }

}
@media (device-height:480px) and (-webkit-min-device-pixel-ratio:2){/* 兼容iphone4/4s */
  .main_view {
    height: auto; /* 移动端高度自适应 */
  }
  .form_view {
    width: 94%; /* 移动端占满屏幕宽度 */
    margin: auto;
  }
}

@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){/* 兼容iphone5 */
  .main_view {
    height: auto; /* 移动端高度自适应 */
  }
  .form_view {
    width: 94%; /* 移动端占满屏幕宽度 */
    margin: auto;
  }
}

@media (device-height:667px) and (-webkit-min-device-pixel-ratio:2){/* 兼容iphone6 */
  .main_view {
    height: auto; /* 移动端高度自适应 */
  }
  .form_view {
    width: 94%; /* 移动端占满屏幕宽度 */
    margin: auto;
  }
}
@media (device-height:736px) and (-webkit-min-device-pixel-ratio:2){/* 兼容iphone6 Plus */
  .main_view {
    height: auto; /* 移动端高度自适应 */
  }
  .form_view {
    width: 94%; /* 移动端占满屏幕宽度 */
    margin: auto;
  }
}

</style>



// WEBPACK FOOTER //
// src/view/yinsi.vue